<template>
	<select id="currencies" v-model="selectedCurrency" class="mt-0 form-select max-w-fit font-semibold">
		<option
			:data-sort="currency.sort_order"
			v-for="(currency, currencyIndex) in sortedCurrencies" :key="currencyIndex"
			:value="currency.code">
				{{ currency.code }}
		</option>
	</select>
</template>

<script>
  export default {
  	props: {
  		currencyData: {
  			type: [Array, Object],
  			required: true
  		}
  	},

    data() {
		return {
			selectedCurrency: null
		}
    },

    mounted() {
    	if (! localStorage.getItem(`reopt_selectedCurrency`)) {
    		localStorage.setItem(`reopt_selectedCurrency`, 'USD');
    	}

    	this.selectedCurrency = localStorage.getItem(`reopt_selectedCurrency`);

    	this.insertCurrencyDivider();

    	this.$eventHub.$on('convert-currency', (params) => {
    		let to = params?.to ? params.to : localStorage.getItem(`reopt_selectedCurrency`) || 'USD';
    		let from = params?.from ? params.from : localStorage.getItem(`reopt_baseCurrency`) || 'USD';

    		this.convert(to, from);
    	});
    },

    watch: {
    	selectedCurrency(to) {
    		if (! ['---', null].includes(to)) {
    			localStorage.setItem(`reopt_selectedCurrency`, to);

    			this.$nextTick(() => {
	    			if (to == localStorage.getItem(`reopt_baseCurrency`)) {
	    				this.restoreOriginalCurrencyValues();
	    			} else {
	    				this.convert(to, localStorage.getItem(`reopt_baseCurrency`) || 'USD');
	    			}
    			});
    		}
    	}
    },

    computed: {
    	sortedCurrencies() {
    		return _.sortBy(this.currencyData, ['sort_order', 'code']);
    	}
    },

    methods: {
		convert(to, from) {
			axios.post('/api/get-exchange-rate', {
				from: from,
				to: to
			}).then(response => {			
				let exchangeRate = response.data;

				this.convertCurrencyFields(exchangeRate, to);
				this.convertShorthandCurrencyFields(exchangeRate, to);
			}).catch(error => {
				console.log(error);
			})
		},

		convertCurrencyFields(exchangeRate, to) {
			let elements = document.getElementsByClassName('is-currency');

			for (var i = 0; i < elements.length; i++) {
				var element = elements[i];
				var isInputText = element instanceof HTMLInputElement;
				var value = Number.prototype.cleanseFloat(element.dataset.originalvalue);
				var newValue = value * exchangeRate;
				var precision = element.dataset.precision != undefined ? element.dataset.precision : Number.prototype.isFloat(value) ? 2 : 0;

				if (isInputText) {
					var formatted = this.formatCurrency(newValue * 100, precision, to);
					element.value = formatted
				} else {
					formatted = this.formatCurrency(newValue, precision, to);
					element.innerText = formatted;
				}
			}
		},

		convertShorthandCurrencyFields(exchangeRate, to) {
			let elements = document.getElementsByClassName('is-shorthand-currency');

			for (var i = 0; i < elements.length; i++) {
				let element = elements[i];
				let value = element.dataset.originalvalue;
				let unit = value.substring(value.length - 1);
				let cleansed = Number.prototype.cleanseFloat(element.dataset.originalvalue);
				let newValue = 0;

				switch (unit) {
					case 'K':
						newValue = cleansed * 1000;
						break;
					case 'M':
						newValue = cleansed * 1000000;
						break;
					case 'B':
						newValue = cleansed * 1000000000;
						break;
				}

				newValue = (newValue * exchangeRate) * 100;
				let formatted = this.formatCurrency(newValue, 0, to);

				element.innerText = this.shortenCurrency(formatted);
			}
		},

		shortenCurrency(amount) {
			let symbol = amount.substring(0, 1);
			amount = amount.toString().replace(/[^\d.-]/g, '');

			if (amount >= 1000000000) {
				amount = parseFloat(amount / 1000000000).toFixed(1);
				return symbol + amount + "B";
			}

			if (amount >= 1000000) {
				amount = parseFloat(amount / 1000000).toFixed(1);
				return symbol + amount + 'M';
			}

			if (amount >= 1000) {
				amount = parseFloat(amount / 1000).toFixed(1);
				return symbol + amount + 'K';
			}

			return symbol + parseFloat(amount).toFixed(1);
		},

		restoreOriginalCurrencyValues() {
			let elements = document.querySelectorAll('.is-currency, .is-shorthand-currency');

			for (var i = 0; i < elements.length; i++) {
				var element = elements[i];
				var isInputText = element instanceof HTMLInputElement;
				
				if (isInputText) {
						var value = Number.prototype.cleanseFloat(element.dataset.originalvalue);
						var precision = element.dataset.precision != undefined ? element.dataset.precision : Number.prototype.isFloat(value) ? 2 : 0;

						element.value = this.formatCurrency(value * 100, precision);
				} else {
					if (element.classList.contains('is-currency')) {
						value = Number.prototype.cleanseFloat(element.dataset.originalvalue);
						precision = element.dataset.precision != undefined ? element.dataset.precision : Number.prototype.isFloat(value) ? 2 : 0;

						element.innerText = this.formatCurrency(value, precision);
					} else if (element.classList.contains('is-shorthand-currency')) {
						element.innerText = "$" + element.dataset.originalvalue;
					}
				}
			}
		},

		insertCurrencyDivider() {
			let currencySelector = document.querySelector('#currencies');

	    	for (let currency of currencySelector.options) {
				if (! currency.hasAttribute("data-sort")) {
					const newNode = document.createElement("option");
					const textNode = document.createTextNode("---");
					newNode.appendChild(textNode);
					// Purely a visual separator between sorted and unsorted
					// currencies - without this it is a selectable option and
					// "---" can end up showing as the chosen currency.
					newNode.disabled = true;
					newNode.setAttribute("aria-hidden", "true");

					currencySelector.insertBefore(newNode, currency);

					return;
				}
			}
		}
    },
  }
</script>